module.exports = __webpack_public_path__ + "img/company-logo.8cc12968.svg";